import { useMemo } from 'react';
import { useCalendarService } from '@mews-commander/ui';
import { useAppClockService, useDateTimeLocalizationInfo, useTimezone } from '@mews/framework';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { TimeUnitPeriod } from '@mews-commander/data-access';
import { getDateTimeBoundaries } from './dateTime';

export const useNewReservationDateTimeBoundaries = (
    arrivalDate: string,
    departureDate: string,
    arrivalHours: string,
    departureHours: string,
    timeUnitPeriod: TimeUnitPeriod
) => {
    const timezone = useTimezone();
    const enterprise = useCurrentEnterprise();
    const localizationInfo = useDateTimeLocalizationInfo();
    const appClockService = useAppClockService();
    const calendarService = useCalendarService();

    return useMemo(
        () =>
            getDateTimeBoundaries(
                arrivalDate,
                departureDate,
                arrivalHours,
                departureHours,
                appClockService.getAppNowUtc(),
                enterprise.operationalEditableHistoryWindow,
                timezone,
                timeUnitPeriod,
                localizationInfo,
                calendarService.isDateEqual
            ),
        [
            appClockService,
            arrivalDate,
            arrivalHours,
            calendarService.isDateEqual,
            departureDate,
            departureHours,
            localizationInfo,
            enterprise.operationalEditableHistoryWindow,
            timezone,
            timeUnitPeriod,
        ]
    );
};
